import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { queriesInvoices } from "@query";
import { WSQueries } from "../../query/WSQuery";
import { InvoicesForm } from "../components/InvoicesForm/InvoicesForm";
import { useDefaultInvoiceSubject } from "../utils";
import {
  convertToLineItemFormDataFromV3,
  creditFeeToFormDataFromV3,
  defaultFrequency,
  invoiceSplitsToFormData,
  lateFeeToFormDataFromV3,
  paymentMethodsToFormDataFromV3
} from "../utils/invoicesFormUtils";

type Props = RouteComponentProps<{ invoiceId: string }>;

export const InvoicesDuplicateInvoice: React.FC<Props> = ({ match }) => {
  const invoiceId = match.params.invoiceId;
  const queryInvoice = queriesInvoices.getInvoice.useQuery({ invoiceId });

  const defaultSubject = useDefaultInvoiceSubject();

  return (
    <WSQueries queries={{ queryInvoice }}>
      {({ queryInvoice: { data: invoice } }) => (
        <InvoicesForm
          defaultValues={{
            subject: String(invoice.metadata?.subject) || defaultSubject,
            payer: {
              payerId: invoice.payerId || null,
              payerEngagementId: invoice.payerEngagementId || null,
              emailsCC: []
            },
            lineItems: (invoice?.lineItems || []).map(
              convertToLineItemFormDataFromV3
            ),
            other: {
              projectName: String(invoice?.metadata?.projectName || ""),
              notes: invoice?.notes || "",
              // Attachments are disabled (no upload path on either API).
              attachments: []
            },
            due:
              invoice?.dueDate && invoice.dueDate > new Date()
                ? "custom"
                : "on-receipt",
            customDueDate:
              invoice?.dueDate && invoice.dueDate > new Date()
                ? invoice?.dueDate
                : new Date(),
            includesLateFee:
              !!invoice.lateFeeHandling && !!invoice.lateFeeHandling?.frequency,
            lateFee: lateFeeToFormDataFromV3(invoice.lateFeeHandling),
            send: {
              type: "immediately",
              date: new Date()
            },
            recurring: false,
            frequency: defaultFrequency,
            splits: invoiceSplitsToFormData(invoice.splits),
            paymentMethods: paymentMethodsToFormDataFromV3(
              invoice.acceptedPaymentMethods
            ),
            advanced: {
              sendEmails: !!invoice?.notificationPreferences?.shouldSendInvoice,
              sendReminders:
                !!invoice?.notificationPreferences?.shouldSendReminders,
              creditFeeHandling: creditFeeToFormDataFromV3(
                invoice.creditFeeHandling
              ),
              date: new Date()
            }
          }}
        />
      )}
    </WSQueries>
  );
};
